/* Copyright (C) Nicolas Lochet - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Nicolas Lochet <nicolas@lochet.com>, 2025
 */

export function defineModal (i18n) {
  i18n.modal = {}
  i18n.modal.logout_confirmation = 'Etes-vous sur de vouloir quitter le jeux ?'
  i18n.modal.confirm = 'Confirmer'
  i18n.modal.cancel = 'Annuler'
  i18n.modal.close = 'Fermer'
  i18n.modal.test = 'Test'
}
